import PropTypes from "prop-types";

import { t } from "../../services";
import { TabButtonStyled } from "./styled";

const TabButton = ({ title, active, onClick = () => {} }) => {
  return (
    <TabButtonStyled active={active} onClick={onClick}>
      {t(title)}
    </TabButtonStyled>
  );
};

TabButton.propTypes = {
  title: PropTypes.string.isRequired,
  active: PropTypes.bool,
  onClick: PropTypes.func.isRequired
};

export default TabButton;
